'use client';

import { c as _c } from "react/compiler-runtime";
import { setDisplayFlat } from '@lib/store/slices/FlatSlice';
import { useViewport } from '@lib/tools/hooks/useViewport';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import style from './FlatConfigure.module.scss';
const FlatConfigureBtns = t0 => {
  const $ = _c(22);
  const {
    active,
    bulk,
    tabsContainerRef
  } = t0;
  const {
    isMobile
  } = useViewport();
  const btns = useSelector(_temp);
  const genPlan = useSelector(_temp2);
  const getTestId = _temp3;
  const setId = _temp4;
  const dispatch = useDispatch();
  let t1;
  if ($[0] !== active || $[1] !== bulk || $[2] !== isMobile || $[3] !== tabsContainerRef) {
    t1 = () => {
      if (isMobile && tabsContainerRef.current && bulk !== 9335) {
        const activeTabElement = tabsContainerRef.current.children[0].children[setId(active)];
        activeTabElement.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center"
        });
      }
    };
    $[0] = active;
    $[1] = bulk;
    $[2] = isMobile;
    $[3] = tabsContainerRef;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== active || $[6] !== bulk || $[7] !== isMobile) {
    t2 = [active, isMobile, bulk];
    $[5] = active;
    $[6] = bulk;
    $[7] = isMobile;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  useEffect(t1, t2);
  let t3;
  if ($[9] !== active || $[10] !== btns || $[11] !== bulk || $[12] !== dispatch || $[13] !== genPlan) {
    let t4;
    if ($[15] !== active || $[16] !== bulk || $[17] !== dispatch || $[18] !== genPlan) {
      t4 = btn => {
        if (bulk === 9335 && btn.name === "\u0421 \u0440\u0430\u0437\u043C\u0435\u0440\u0430\u043C\u0438") {
          return null;
        }
        return <button key={btn.id} onClick={() => dispatch(setDisplayFlat(btn.characteristic))} className={btn.characteristic !== active ? style.flatConfigureBtns__btn : `${style.flatConfigureBtns__btn} ${style.flatConfigureBtns__active}`} data-testid={getTestId(btn.id)}><div className={genPlan === true ? style.planText : style.text}>{btn.name}</div></button>;
      };
      $[15] = active;
      $[16] = bulk;
      $[17] = dispatch;
      $[18] = genPlan;
      $[19] = t4;
    } else {
      t4 = $[19];
    }
    t3 = btns.map(t4);
    $[9] = active;
    $[10] = btns;
    $[11] = bulk;
    $[12] = dispatch;
    $[13] = genPlan;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[20] !== t3) {
    t4 = <div className={style.flatConfigureBtns}>{t3}</div>;
    $[20] = t3;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  return t4;
};
export default FlatConfigureBtns;
function _temp(state) {
  return state.flatInfo.flatConfigure;
}
function _temp2(state_0) {
  return state_0?.flatInfo?.flatGenPlan;
}
function _temp3(id) {
  const viewsArray = ["furnishedView", "dimensionsView", "floorView", "genplanView"];
  return viewsArray[id - 1];
}
function _temp4(active_0) {
  switch (active_0) {
    case "withFurniture":
      {
        return 0;
      }
    case "withSize":
      {
        return 1;
      }
    case "onFloor":
      {
        return 2;
      }
    case "onGenplan":
      {
        return 3;
      }
    default:
      {
        return 0;
      }
  }
}